export const footerMoreLinks = {
  'om-ar': [
    {
      title: 'أكثر',
      items: [
        {
          href: 'https://om.wingie.com/contact/',
          title: 'التواصل',
        },
        {
          href: 'https://om.wingie.com/faq/',
          title: 'الأسئلة المتكررة',
        },
        {
          href: 'https://om.wingie.com/about-us/',
          title: 'تعرّف علينا',
        },
        {
          href: 'https://om.wingie.com/privacy/',
          title: 'الخصوصية - وينجي',
        },
        {
          href: 'https://om.wingie.com/terms-and-conditions/',
          title: 'شروط الاستخدام',
        },
        {
          href: 'https://om.wingie.com/awards/',
          title: 'جوائزنا',
        },
      ],
    },
  ],
  'om-en': [
    {
      title: 'More',
      items: [
        {
          href: 'https://om.wingie.com/en/contact/',
          title: 'Contact',
        },
        {
          href: 'https://om.wingie.com/en/faq/',
          title: 'Frequently Asked Questions',
        },
        {
          href: 'https://om.wingie.com/en/about-us/',
          title: 'About us',
        },
        {
          href: 'https://om.wingie.com/en/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://om.wingie.com/en/terms-and-conditions/',
          title: 'Terms and Conditions',
        },
        {
          href: 'https://om.wingie.com/en/awards/',
          title: 'Our Awards',
        },
      ],
    },
  ],
  'om-es': [
    {
      title: 'Más',
      items: [
        {
          href: 'https://om.wingie.com/es/contacto/',
          title: 'Contacto',
        },
        {
          href: 'https://om.wingie.com/es/preguntas-frecuentes/',
          title: 'Preguntas más frecuentes',
        },
        {
          href: 'https://om.wingie.com/es/acerca-de-nosotros/',
          title: 'Sobre nosotros',
        },
        {
          href: 'https://om.wingie.com/es/privacidad/',
          title: 'Privacidad',
        },
        {
          href: 'https://om.wingie.com/es/terminos-y-condiciones/',
          title: 'Términos y condiciones de uso',
        },
        {
          href: 'https://om.wingie.com/es/awards/',
          title: 'Nuestros premios',
        },
      ],
    },
  ],
  'om-de': [
    {
      title: 'Mehr',
      items: [
        {
          href: 'https://om.wingie.com/de/kontakt/',
          title: 'Kontakt',
        },
        {
          href: 'https://om.wingie.com/de/faq/',
          title: 'Häufig gestellte Fragen - Wingie',
        },
        {
          href: 'https://om.wingie.com/de/uber-uns/',
          title: 'Über uns',
        },
        {
          href: 'https://om.wingie.com/de/datenschutz/',
          title: 'Datenschutz & Cookies',
        },
        {
          href: 'https://om.wingie.com/de/allgemeine-geschaeftsbedingungen/',
          title: 'Allgemeine Geschäftsbedingungen',
        },
        {
          href: 'https://om.wingie.com/de/awards/',
          title: 'Unsere Auszeichnungen',
        },
      ],
    },
  ],
  'om-ru': [
    {
      title: 'более',
      items: [
        {
          href: 'https://om.wingie.com/ru/contact/',
          title: 'Контакты',
        },
        {
          href: 'https://om.wingie.com/ru/faq/',
          title: 'Часто задаваемые вопросы',
        },
        {
          href: 'https://om.wingie.com/ru/about-us/',
          title: 'О нас',
        },
        {
          href: 'https://om.wingie.com/ru/privacy/',
          title: 'Конфиденциальность',
        },
        {
          href: 'https://om.wingie.com/ru/terms-and-conditions/',
          title: 'Условия и положения',
        },
        {
          href: 'https://om.wingie.com/ru/awards/',
          title: 'Наши награды',
        },
      ],
    },
  ],
  'om-it': [
    {
      title: 'Di più',
      items: [
        {
          href: 'https://om.wingie.com/it/contact/',
          title: 'Contatto',
        },
        // {
        //     href: 'https://om.wingie.com/it/faq/',
        //     title: 'Domande Frequenti',
        // },
        {
          href: 'https://om.wingie.com/it/about-us/',
          title: 'Chi siamo',
        },
        {
          href: 'https://om.wingie.com/it/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://om.wingie.com/it/terms-and-conditions/',
          title: 'Termini e Condizioni',
        },
        {
          href: 'https://om.wingie.com/it/awards/',
          title: 'I Nostri Premi',
        },
      ],
    },
  ],
  'om-fr': [
    {
      title: 'Plus',
      items: [
        {
          href: 'https://om.wingie.com/fr/contact/',
          title: 'Contact',
        },
        // {
        //     href: 'https://om.wingie.com/fr/faq/',
        //     title: 'Questions Fréquemment Posées',
        // },
        {
          href: 'https://om.wingie.com/fr/about-us/',
          title: 'À propos de nous',
        },
        {
          href: 'https://om.wingie.com/fr/privacy/',
          title: 'Confidentialité',
        },
        {
          href: 'https://om.wingie.com/fr/terms-and-conditions/',
          title: 'Termes et Conditions',
        },
        {
          href: 'https://om.wingie.com/fr/awards/',
          title: 'Nos Prix',
        },
      ],
    },
  ],
  'om-pt': [
    {
      title: 'Mais',
      items: [
        {
          href: 'https://om.wingie.com/pt/contact/',
          title: 'Contato',
        },
        // {
        //     href: 'https://om.wingie.com/pt/faq/',
        //     title: 'Perguntas Frequentes',
        // },
        {
          href: 'https://om.wingie.com/pt/about-us/',
          title: 'Sobre nós',
        },
        {
          href: 'https://om.wingie.com/pt/privacy/',
          title: 'Privacidade',
        },
        {
          href: 'https://om.wingie.com/pt/terms-and-conditions/',
          title: 'Termos e Condições',
        },
        {
          href: 'https://om.wingie.com/pt/awards/',
          title: 'Nossos Prêmios',
        },
      ],
    },
  ],
  'om-ro': [
    {
      title: 'Mai mult',
      items: [
        {
          href: 'https://om.wingie.com/ro/contact/',
          title: 'Contact',
        },
        // {
        //     href: 'https://om.wingie.com/ro/faq/',
        //     title: 'Întrebări Frecvente',
        // },
        {
          href: 'https://om.wingie.com/ro/about-us/',
          title: 'Despre noi',
        },
        {
          href: 'https://om.wingie.com/ro/privacy/',
          title: 'Confidențialitate',
        },
        {
          href: 'https://om.wingie.com/ro/terms-and-conditions/',
          title: 'Termeni și Condiții',
        },
        {
          href: 'https://om.wingie.com/ro/awards/',
          title: 'Premiile Noastre',
        },
      ],
    },
  ],
  'om-pl': [
    {
      title: 'Więcej',
      items: [
        {
          href: 'https://om.wingie.com/pl/contact/',
          title: 'Kontakt',
        },
        // {
        //     href: 'https://om.wingie.com/pl/faq/',
        //     title: 'Często Zadawane Pytania',
        // },
        {
          href: 'https://om.wingie.com/pl/about-us/',
          title: 'O nas',
        },
        {
          href: 'https://om.wingie.com/pl/privacy/',
          title: 'Prywatność',
        },
        {
          href: 'https://om.wingie.com/pl/terms-and-conditions/',
          title: 'Warunki',
        },
        {
          href: 'https://om.wingie.com/pl/awards/',
          title: 'Nasze Nagrody',
        },
      ],
    },
  ],
  'om-lt': [
    {
      title: 'Daugiau',
      items: [
        {
          href: 'https://om.wingie.com/lt/contact/',
          title: 'Kontaktai',
        },
        // {
        //     href: 'https://om.wingie.com/lt/faq/',
        //     title: 'Dažnai Užduodami Klausimai',
        // },
        {
          href: 'https://om.wingie.com/lt/about-us/',
          title: 'Apie mus',
        },
        {
          href: 'https://om.wingie.com/lt/privacy/',
          title: 'Privatumas',
        },
        {
          href: 'https://om.wingie.com/lt/terms-and-conditions/',
          title: 'Sąlygos',
        },
        {
          href: 'https://om.wingie.com/lt/awards/',
          title: 'Mūsų Apdovanojimai',
        },
      ],
    },
  ],
  'om-uz': [
    {
      title: "Ko'proq",
      items: [
        {
          href: 'https://om.wingie.com/uz/contact/',
          title: 'Aloqa',
        },
        // {
        //     href: 'https://om.wingie.com/uz/faq/',
        //     title: "Ko'p Beriladigan Savollar",
        // },
        {
          href: 'https://om.wingie.com/uz/about-us/',
          title: 'Biz haqimizda',
        },
        {
          href: 'https://om.wingie.com/uz/privacy/',
          title: 'Maxfiylik',
        },
        {
          href: 'https://om.wingie.com/uz/terms-and-conditions/',
          title: 'Shartlar',
        },
        {
          href: 'https://om.wingie.com/uz/awards/',
          title: 'Bizning mukofotlarimiz',
        },
      ],
    },
  ],
  'om-sr': [
    {
      title: 'Више',
      items: [
        {
          href: 'https://om.wingie.com/sr/contact/',
          title: 'Контакт',
        },
        // {
        //     href: 'https://om.wingie.com/sr/faq/',
        //     title: 'Често Постављана Питања',
        // },
        {
          href: 'https://om.wingie.com/sr/about-us/',
          title: 'О нама',
        },
        {
          href: 'https://om.wingie.com/sr/privacy/',
          title: 'Приватност',
        },
        {
          href: 'https://om.wingie.com/sr/terms-and-conditions/',
          title: 'Услови',
        },
        {
          href: 'https://om.wingie.com/sr/awards/',
          title: 'Наше награде',
        },
      ],
    },
  ],
  'om-ky': [
    {
      title: 'Дагы',
      items: [
        {
          href: 'https://om.wingie.com/ky/contact/',
          title: 'Байланыш',
        },
        // {
        //     href: 'https://om.wingie.com/ky/faq/',
        //     title: 'Көп берилген суроолор',
        // },
        {
          href: 'https://om.wingie.com/ky/about-us/',
          title: 'Биз жөнүндө',
        },
        {
          href: 'https://om.wingie.com/ky/privacy/',
          title: 'Купуялык',
        },
        {
          href: 'https://om.wingie.com/ky/terms-and-conditions/',
          title: 'Шарттар',
        },
        {
          href: 'https://om.wingie.com/ky/awards/',
          title: 'Биздин сыйлыктар',
        },
      ],
    },
  ],
  'om-tg': [
    {
      title: 'Бештар',
      items: [
        {
          href: 'https://om.wingie.com/tg/contact/',
          title: 'Тамос',
        },
        // {
        //     href: 'https://om.wingie.com/tg/privacy/',
        //     title: 'Саволҳои зиёд додашаванда',
        // },
        {
          href: 'https://om.wingie.com/tg/about-us/',
          title: 'Дар бораи мо',
        },
        {
          href: 'https://om.wingie.com/tg/privacy/',
          title: 'Махфият',
        },
        {
          href: 'https://om.wingie.com/tg/terms-and-conditions/',
          title: 'Шартҳо',
        },
        {
          href: 'https://om.wingie.com/tg/awards/',
          title: 'Ҷоизаҳои мо',
        },
      ],
    },
  ],
  'om-kk': [
    {
      title: 'Көбірек',
      items: [
        {
          href: 'https://om.wingie.com/kk/contact/',
          title: 'Байланыс',
        },
        // {
        //     href: 'https://om.wingie.com/kk/faq/',
        //     title: 'Жиі қойылатын сұрақтар',
        // },
        {
          href: 'https://om.wingie.com/kk/about-us/',
          title: 'Біз туралы',
        },
        {
          href: 'https://om.wingie.com/kk/privacy/',
          title: 'Maxfiylik',
        },
        {
          href: 'https://om.wingie.com/kk/terms-and-conditions/',
          title: 'Шарттар',
        },
        {
          href: 'https://om.wingie.com/kk/awards/',
          title: 'Біздің марапаттар',
        },
      ],
    },
  ],
  'om-nl': [
    {
      title: 'Meer',
      items: [
        {
          href: 'https://om.wingie.com/nl/contact/',
          title: 'Contact',
        },
        // {
        //     href: 'https://om.wingie.com/nl/faq/',
        //     title: 'Veelgestelde Vragen',
        // },
        {
          href: 'https://om.wingie.com/nl/about-us/',
          title: 'Over ons',
        },
        {
          href: 'https://om.wingie.com/nl/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://om.wingie.com/nl/terms-and-conditions/',
          title: 'Voorwaarden',
        },
        {
          href: 'https://om.wingie.com/nl/awards/',
          title: 'Onze Prijzen',
        },
      ],
    },
  ],
  'om-ja': [
    {
      title: 'もっと',
      items: [
        { title: 'お問い合わせ', href: 'https://om.wingie.com/ja/contact/' },
        { title: 'よくある質問', href: 'https://om.wingie.com/en/faq/' },
        { title: '会社概要', href: 'https://om.wingie.com/ja/about-us/' },
        { title: 'プライバシーポリシー', href: 'https://om.wingie.com/ja/privacy/' },
        { title: '利用規約', href: 'https://om.wingie.com/ja/terms-and-conditions/' },
        { title: '受賞歴', href: 'https://om.wingie.com/ja/awards/' },
      ],
    },
  ],
  'om-zh': [
    {
      title: '更多',
      items: [
        { title: '联系方式', href: 'https://om.wingie.com/zh/contact/' },
        { title: '常见问题', href: 'https://om.wingie.com/en/faq/' },
        { title: '关于我们', href: 'https://om.wingie.com/zh/about-us/' },
        { title: '隐私政策', href: 'https://om.wingie.com/zh/privacy/' },
        { title: '条款和条件', href: 'https://om.wingie.com/zh/terms-and-conditions/' },
        { title: '我们的奖项', href: 'https://om.wingie.com/zh/awards/' },
      ],
    },
  ],
  'om-ko': [
    {
      title: '더보기',
      items: [
        { title: '연락처', href: 'https://om.wingie.com/ko/contact/' },
        { title: '자주 묻는 질문', href: 'https://om.wingie.com/en/faq/' },
        { title: '회사 소개', href: 'https://om.wingie.com/ko/about-us/' },
        { title: '개인정보처리방침', href: 'https://om.wingie.com/ko/privacy/' },
        { title: '이용약관', href: 'https://om.wingie.com/ko/terms-and-conditions/' },
        { title: '수상 내역', href: 'https://om.wingie.com/ko/awards/' },
      ],
    },
  ],
  'om-hi': [
    {
      title: 'अधिक',
      items: [
        { title: 'संपर्क करें', href: 'https://om.wingie.com/hi/contact/' },
        { title: 'सामान्य प्रश्न', href: 'https://om.wingie.com/en/faq/' },
        { title: 'हमारे बारे में', href: 'https://om.wingie.com/hi/about-us/' },
        { title: 'गोपनीयता', href: 'https://om.wingie.com/hi/privacy/' },
        { title: 'नियम और शर्तें', href: 'https://om.wingie.com/hi/terms-and-conditions/' },
        { title: 'हमारे पुरस्कार', href: 'https://om.wingie.com/hi/awards/' },
      ],
    },
  ],
  'om-ta': [
    {
      title: 'மேலும்',
      items: [
        { title: 'தொடர்பு', href: 'https://om.wingie.com/ta/contact/' },
        { title: 'அடிக்கடி கேட்கப்படும் கேள்விகள்', href: 'https://om.wingie.com/en/faq/' },
        { title: 'எங்கள் பற்றி', href: 'https://om.wingie.com/ta/about-us/' },
        { title: 'தனியுரிமை', href: 'https://om.wingie.com/ta/privacy/' },
        { title: 'விதிமுறைகள்', href: 'https://om.wingie.com/ta/terms-and-conditions/' },
        { title: 'எங்கள் விருதுகள்', href: 'https://om.wingie.com/ta/awards/' },
      ],
    },
  ],
  'om-th': [
    {
      title: 'เพิ่มเติม',
      items: [
        { title: 'ติดต่อเรา', href: 'https://om.wingie.com/th/contact/' },
        { title: 'คำถามที่พบบ่อย', href: 'https://om.wingie.com/en/faq/' },
        { title: 'เกี่ยวกับเรา', href: 'https://om.wingie.com/th/about-us/' },
        { title: 'นโยบายความเป็นส่วนตัว', href: 'https://om.wingie.com/th/privacy/' },
        { title: 'ข้อกำหนดและเงื่อนไข', href: 'https://om.wingie.com/th/terms-and-conditions/' },
        { title: 'รางวัลของเรา', href: 'https://om.wingie.com/th/awards/' },
      ],
    },
  ],
  'om-ur': [
    {
      title: 'مزید',
      items: [
        { title: 'رابطہ کریں', href: 'https://om.wingie.com/ur/contact/' },
        { title: 'عمومی سوالات', href: 'https://om.wingie.com/en/faq/' },
        { title: 'ہمارے بارے میں', href: 'https://om.wingie.com/ur/about-us/' },
        { title: 'رازداری', href: 'https://om.wingie.com/ur/privacy/' },
        { title: 'شرائط و ضوابط', href: 'https://om.wingie.com/ur/terms-and-conditions/' },
        { title: 'ہمارے اعزازات', href: 'https://om.wingie.com/ur/awards/' },
      ],
    },
  ],
  'om-ka': [
    {
      title: 'მეტი',
      items: [
        { title: 'კონტაქტი', href: 'https://om.wingie.com/ka/contact/' },
        { title: 'ხშირად დასმული კითხვები', href: 'https://om.wingie.com/en/faq/' },
        { title: 'ჩვენ შესახებ', href: 'https://om.wingie.com/ka/about-us/' },
        { title: 'კონფიდენციალურობა', href: 'https://om.wingie.com/ka/privacy/' },
        { title: 'წესები და პირობები', href: 'https://om.wingie.com/ka/terms-and-conditions/' },
        { title: 'ჩვენი ჯილდოები', href: 'https://om.wingie.com/ka/awards/' },
      ],
    },
  ],
}
